export const SET_DEPARTMENTS = "setDepartments";
export const SET_DEPARTMENTS_TOTAL = "setDepartmentsTotal";
export const SET_DEPARTMENT = "setForm";
export const SET_LOADING = "setLoading";

export default {
  [SET_DEPARTMENTS](state, supervisor_departments) {
    state.supervisor_departments = supervisor_departments;
  },
  [SET_DEPARTMENTS_TOTAL](state, totalCount) {
    state.totalCount = totalCount;
  },
  [SET_DEPARTMENT](state, supervisor_department) {
    state.supervisor_department = supervisor_department;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};
